import { render, staticRenderFns } from "./TournamentSingle.vue?vue&type=template&id=b989ebd6&"
import script from "./TournamentSingle.vue?vue&type=script&lang=js&"
export * from "./TournamentSingle.vue?vue&type=script&lang=js&"
import style0 from "./TournamentSingle.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TournamentSingle.vue"
export default component.exports